module.exports = __webpack_public_path__ + "img/s8_pen1.bf34bb5b.png";